import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const state = {
	fetchLoading: false,
  //origin: 'O5qiAH9b'
  origin: 'MasterCard-会籍匹配',
  originName: 'MasterCard',
  userInfo: 'MasterCard_membership_UserInfo',
  userToken: 'MasterCard_membership_Token',
  userId: 'MasterCard_membership_UserId',
  userLevel: 'MasterCard_membership_UserLevel',
  pageHash: 'MasterCard_membershipHash',
  hasValidate: false,
  pageType: '',
  keepAlive: '',
  location: 'MASTERCARD_LOCATION'
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})


// WEBPACK FOOTER //
// ./src/store/index.js